import { Component, Input, signal, ViewChild } from '@angular/core';
import { ExpandableAreaComponent } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-builder-palette-collapsible-section',
  standalone: false,
  templateUrl: './lm-builder-palette-collapsible-section.component.html',
  styleUrl: './lm-builder-palette-collapsible-section.component.scss',
})
export class LMBuilderPaletteCollapsibleSectionComponent {

  @Input() label: string | undefined;
  @Input() fields: Array<LMBuilderField> = [];

  @ViewChild(ExpandableAreaComponent) expandableArea: ExpandableAreaComponent | undefined;

  private defaultButtonIcon = 'chevron-up';
  buttonIcon = signal(this.defaultButtonIcon);

  private open = true;

  constructor() { }

  toggleHeaders($event: Event) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if (this.expandableArea) {
      if (this.open) {
        this.expandableArea.close();
        this.open = false;
      } else {
        this.expandableArea.open();
        this.open = true;
      }
      this.setIcon();
    }
  }

  setIcon() {
    if (this.open) {
      this.buttonIcon.set('chevron-up');
    } else {
      this.buttonIcon.set('chevron-down');
    }
  }
}
